import { Form, Input, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AccountService from "../../../../../Services/AccountService";
import UserService from "../../../../../Services/UserService";
import ClinicService from "../../../../../Services/ClinicService";
import { convertUTCDate } from "../../../../../utils/convertionFunc";
import { useDispatch, useSelector } from "react-redux";
import { handleSetPatientRegistrationPayload } from "../../../../../Redux/actions/patientActions";

function RpmDetails({
  handleCancel,
  handleNext,
  handlePrevious,
  currPageView,
}) {
  const [usersList, setUsersList] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [clinicList, setClinicList] = useState([]);
  const [selectedClinic, setSelectedClinic] = useState(null);
  const [selectedAcc, setSelectedAcc] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const history = useHistory();
  const formRef = useRef();
  const dispatch = useDispatch();
  const { registrationPayload, selectedEditPatient } = useSelector(
    (state) => state.patients
  );
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    if (selectedEditPatient && !selectedAcc && !selectedClinic) {
      if (selectedEditPatient.hospitalId) {
        setSelectedAcc({ account_Id: selectedEditPatient.hospitalId });
      }
      if (selectedEditPatient.hospitalId && selectedEditPatient.locationId) {
        setSelectedClinic({
          account_Id: selectedEditPatient.hospitalId,
          clinic_Id: selectedEditPatient.locationId,
        });
        if (selectedEditPatient.providerCode) {
          setSelectedDoc({
            account_Id: selectedClinic?.account_Id,
            clinic_Id: selectedClinic?.clinic_Id,
            userId: selectedEditPatient?.providerCode,
          });
        }
      }
      formRef.current.setFieldsValue({
        hospitalId: selectedEditPatient.hospitalId,
        locationId: selectedEditPatient.locationId,
        userId: selectedEditPatient.providerCode,
        uhId: selectedEditPatient.uhId,
      });
    }
  }, [selectedEditPatient]);

  useEffect(() => {
    if (!loggedUser) {
      return history.push("/");
    }
    getAccountList();
    fetchClinicList();
    getUsersList();
  }, []);

  const getAccountList = async () => {
    let payload = {
      account_Id: loggedUser.user.account_Id,
      accountRoleType: "clinic",
    };

    try {
      const response = await AccountService.AccountList(payload);
      setAccountList(response.data);
      setSelectedAcc(response?.data[0]);
    } catch (error) {
      console.error(error);
    }
  };

  const getUsersList = async () => {
    const userPayload = { pageNo: "1" };
    userPayload.account_Id = loggedUser.user.account_Id;
    userPayload.clinic_Id = loggedUser.user.clinic_Id;
    try {
      const response = await UserService.getUser(userPayload);
      setUsersList(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleSelectAcc = (value) => {
    if (value) {
      const selected = accountList.find(
        (clinic) => clinic.account_Id === value
      );
      setSelectedAcc(selected);
    } else {
      setSelectedAcc(null);
    }
  };

  const handleSelectClinic = (value) => {
    if (value) {
      const selected = clinicList.find((clinic) => clinic.clinic_Id === value);
      setSelectedClinic(selected);
    } else {
      setSelectedClinic(null);
    }
  };

  const handleClinicSearch = async (label) => {
    if (label && label.length >= 2) {
      const payload = {
        clinic_Name: label,
        account_Id: loggedUser.user.account_Id,
      };
      fetchClinicList(payload);
    } else {
      fetchClinicList({ account_Id: loggedUser.user.account_Id });
    }
  };

  const fetchClinicList = async (filterVal) => {
    const payload = {
      account_Id: loggedUser.user.account_Id,
      status: 1,
    };

    let finalPayload;
    if (filterVal) {
      finalPayload = {
        ...payload,
        ...filterVal,
      };
    }

    try {
      const response = await ClinicService.getClinicList(
        filterVal ? finalPayload : payload
      );
      setClinicList(response.data);
      if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
        const userClinic = response.data.find(
          (item) => item.clinic_Id === loggedUser?.user?.clinic_Id
        );
        setSelectedClinic(userClinic);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleProviderDetailSave = () => {
    const { hospitalId, locationId, userId, uhId } =
      formRef.current.getFieldValue();
    if (!hospitalId || !locationId || !userId) {
      handleNext();
      return;
    }

    if (selectedEditPatient) {
      const isHospitalChanged = selectedEditPatient.hospitalId !== hospitalId;
      const isLocationChanged = selectedEditPatient.locationId !== locationId;
      const isProviderChanged = selectedEditPatient.providerCode !== userId;

      const payload = {
        ...registrationPayload,
        ...(isHospitalChanged && {
          hospitalId,
          hospitalName: selectedAcc.account_Name,
        }),
        ...(isLocationChanged && {
          locationId,
          locationName: selectedClinic.clinic_Name,
        }),
        ...(isProviderChanged && {
          providerCode: userId,
          providerName: `${selectedDoc?.firstName} ${selectedDoc?.lastName}`,
        }),

        modifiedBy: loggedUser?.user?.userId,
        modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      };

      dispatch(handleSetPatientRegistrationPayload(payload));
      handleNext();
    } else {
      const payload = {
        ...registrationPayload,
        hospitalId,
        hospitalName: selectedAcc.account_Name,
        locationId,
        locationName: selectedClinic.clinic_Name,
        modifiedBy: loggedUser?.user?.userId,
        modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        uhId,
        userId,
        providerName: selectedDoc?.firstName + " " + selectedDoc?.lastName,
        providerCode: userId,
      };

      dispatch(handleSetPatientRegistrationPayload(payload));
      handleNext();
    }
  };

  const handleDocChange = (value) => {
    setSelectedDoc(usersList.find((item) => item.userId === value));
  };

  return (
    <div>
      <Form
        className="w-full grid md:grid-cols-4 grid-cols-1 md:justify-center  md:items-center"
        ref={formRef}
      >
        <div className="">
          <div className="">
            <div className="">
              <label className="md:text-xl text-base font-medium ">
                Hospital/Medical Practice
                <span className="text-red-500">*</span>
              </label>
            </div>
            <Form.Item className="md:w-4/5 w-[inherit]" name="hospitalId">
              <Select
                placeholder="Select Hospital"
                className="md:h-8 h-8 outline-none border-2 rounded-lg"
                showSearch
                allowClear
                onChange={handleSelectAcc}
                // onSearch={handleAccSearch}
                options={accountList?.map((acc, idx) => {
                  return {
                    label: acc.account_Name,
                    value: acc.account_Id,
                    key: idx,
                  };
                })}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                dropdownStyle={{ width: "15rem" }}
              />
            </Form.Item>
          </div>
        </div>

        <div>
          <div className="">
            <div className="">
              <label className="md:text-xl text-base font-medium">
                Location
                <span className="text-red-500">*</span>
              </label>
            </div>
            <Form.Item className="md:w-4/5 w-[inherit]" name="locationId">
              <Select
                placeholder="Branch"
                className="md:h-8 h-8 outline-none border-2 rounded-lg"
                onChange={handleSelectClinic}
                onSearch={handleClinicSearch}
                options={clinicList.map((clinic, idx) => {
                  return {
                    label: clinic.clinic_Name,
                    value: clinic.clinic_Id,
                    key: idx,
                  };
                })}
                showSearch
                allowClear
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              />
            </Form.Item>
          </div>
        </div>

        <div className="">
          <div className="">
            <div className="">
              <label className="md:text-xl text-base font-medium">
                Provider
                <span className="text-red-500">*</span>
              </label>
            </div>
            <Form.Item className="md:w-4/5 w-[inherit]" name="userId">
              <Select
                placeholder="Select Doctor"
                className="md:h-8 h-8 outline-none border-2 rounded-lg"
                showSearch
                allowClear
                onChange={handleDocChange}
                options={usersList?.map((user, idx) => {
                  return {
                    label: `${user.firstName} ${user.lastName}`,
                    value: user.userId,
                    key: idx,
                  };
                })}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              />
            </Form.Item>
          </div>
        </div>

        <div className="">
          <div className="">
            <div className="">
              <label className="md:text-lg text-base font-medium">UHID</label>
            </div>
            <Form.Item name="uhId">
              <Input
                placeholder="Enter uhid"
                name="uhid"
                className="md:w-4/5 w-full  md:h-8 h-8 outline-none border-2 p-2 rounded-lg"
              />
            </Form.Item>
          </div>
        </div>
      </Form>
      <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3 ">
        <button
          disabled={currPageView === 1}
          className={`${
            currPageView > 1 ? "block" : "hidden"
          } md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50 text-white`}
          onClick={handlePrevious}
        >
          Previous
        </button>
        <button
          className="md:min-w-24 w-[3rem] md:w-24  h-8 p-1 bg-white rounded-lg border  border-brand-primaryColor font-semibold custom-button-shadow"
          onClick={handleCancel}
        >
          Cancel
        </button>
        <button
          className="md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50 text-white"
          onClick={handleProviderDetailSave}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default RpmDetails;
